module.exports = __webpack_public_path__ + "img/login-logo.35c5cfc4.png";